import { useNavigate } from "react-router-dom";
import { constSelector, useRecoilState, useRecoilValue } from "recoil";
import { isTeamAtom } from "../atoms/isTeamAtom";
import { FieldErrors, useForm } from "react-hook-form";
import { userStateAtom } from "../atoms/userStateAtom";
import { Socket } from "socket.io-client";
import { useState } from "react";
import { SocketProps } from "../types/interface";
import { isMakeRoomShowAtom } from "../atoms/isMakeRoomShowAtom";
import { roomConfigAtom } from "../atoms/roomConfigAtom";

interface MakeRoomForm {
  name: string;
  count: number;
  isParticipate: number;
  gameType: number;
  pw: string;
  maxTime: number;
}

const MakeRoom: React.FC<SocketProps> = ({ socket }) => {
  const navigate = useNavigate();
  const user = useRecoilValue(userStateAtom);
  const userID = user.userData.userIdphp;
  console.log("폼 만들기의 유저 아이디", userID);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<MakeRoomForm>({
    mode: "onChange",
    defaultValues: {
      pw: "",
    },
  });
  const [showMakeRoom, setShowMakeRoom] = useRecoilState(isMakeRoomShowAtom);
  const [roomConfig, setRoomConfig] = useRecoilState(roomConfigAtom);
  const [loading, setLoading] = useState<boolean>(false);

  const onValid = (data: MakeRoomForm) => {
    console.log("방 만들기 넘길 데이터", data);
    setRoomConfig(data);
    const numberCount = +data.count;
    const isParticipateBoolean = Boolean(Number(data.isParticipate));
    console.log("폼데이터", data);
    socket.emit(
      "create_room",
      data.name,
      {
        id: userID,
        maxUser: numberCount,
        ownerParticipate: isParticipateBoolean,
        gameType: data.gameType,
        pw: data.pw,
        maxTime: data.maxTime,
      },
      onCreateRoom
    );
    setLoading(true);
    console.log("onvalid 함수 실행");
  };

  const onInvalid = (errors: FieldErrors) => {
    console.log(errors);
  };

  const onCreateRoom = (status: any, roomName: any) => {
    setShowMakeRoom(false);
    setLoading(false);
    if (status === "ok") {
      navigate("/fun_learning/room", {
        state: { id: userID, roomName },
      });
    }
    if (status === "duplicate") {
      alert("이미 존재하는 방 이름입니다.");
    }
  };

  const onBackToHome = () => {
    setShowMakeRoom(false);
  };
  console.log(user);
  return (
    <div className="h-fit dark:bg-gray-700 bg-gray-200">
      <div className="dark:text-slate-200 font-bold text-slate-800 text-3xl text-center max-w-sm mx-auto mt-3 mb-1"></div>

      <form
        onSubmit={handleSubmit(onValid, onInvalid)}
        className="max-w-md mx-auto p-6 bg-white dark:bg-gray-800 border dark:border-slate-500 dark:shadow-none"
      >
        <div className="flex justify-between">
          {" "}
          <h2 className="text-2xl font-bold text-gray-800 dark:text-slate-200">
            교실 만들기
          </h2>
          <button
            onClick={onBackToHome}
            className="text-slate-800 dark:text-slate-200 font-bold text-3xl transition-colors duration-300 ease-in-out hover:text-blue-500 dark:hover:text-blue-300"
          >
            &larr;
          </button>
        </div>

        <div className="mb-4">
          <label className="block text-gray-700 dark:text-slate-200 font-bold mb-1">
            교실이름
          </label>
          <input
            {...register("name", {
              required: "방이름을 입력하세요",
              maxLength: {
                value: 10,
                message: "교실이름은 10자 이하입니다.",
              },
            })}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 dark:text-white leading-tight focus:outline-none focus:shadow-outline dark:border-gray-600 dark:bg-slate-500"
            type="text"
            placeholder="교실이름을 입력하세요"
          />
          {errors.name && (
            <p className="text-red-500 text-sm mt-1">{errors.name.message}</p>
          )}
        </div>

        <div className="mb-4">
          <label className="block text-gray-700 dark:text-slate-200 font-bold mb-2">
            인원선택
          </label>
          <input
            {...register("count", {
              required: "인원수를 입력하세요",
              min: {
                value: 1,
                message: "최소 인원은 1명입니다.",
              },
              max: {
                value: 40,
                message: "최대 인원은 40명입니다.",
              },
              validate: {
                isNumber: (value) => !isNaN(value) || "Value must be a number",
                isInteger: (value) =>
                  Number.isInteger(Number(value)) || "Value must be an integer",
              },
            })}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 dark:text-white leading-tight focus:outline-none focus:shadow-outline dark:border-gray-600 dark:bg-slate-500"
            type="number"
            placeholder="인원수를 입력하세요"
            defaultValue=""
          />
          {errors.count && (
            <p className="text-red-500 text-sm mt-1">{errors.count.message}</p>
          )}
        </div>

        <div className="mb-4">
          <label className="block text-gray-700 dark:text-slate-200 font-bold mb-2">
            비밀번호
          </label>
          <input
            {...register("pw")}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 dark:text-white leading-tight focus:outline-none focus:shadow-outline dark:border-gray-600 dark:bg-slate-500"
            type="text"
            placeholder="비밀번호를 입력하세요"
          />
        </div>
        <div className="text-sm mb-4 text-gray-700 dark:text-slate-200">
          비밀번호를 기입하지 않으면
          <br />
          비밀번호 없이 방 입장이 가능합니다
        </div>

        <div className="flex gap-10">
          <div className="mb-4">
            <label className="block text-gray-700 dark:text-white font-bold mb-2">
              방장 참여
            </label>
            <div className="mb-4">
              <label className="block text-gray-700 font-bold mb-2">
                <input
                  className="mr-2 leading-tight"
                  type="radio"
                  id="participate"
                  value={1}
                  defaultChecked
                  {...register("isParticipate")}
                />
                <span className="text-sm dark:text-slate-200">참여</span>
              </label>
              <label className="block text-gray-700 font-bold mb-2">
                <input
                  className="mr-2 leading-tight"
                  type="radio"
                  id="not_participate"
                  value={0}
                  {...register("isParticipate")}
                />
                <span className="text-sm dark:text-slate-200">불참</span>
              </label>
            </div>
          </div>

          <div className="mb-1">
            <label className="block text-gray-700 dark:text-white font-bold mb-1">
              학습종류
            </label>
            <div className="mb-4">
              <label className="block text-gray-700 font-bold mb-2">
                <input
                  className="mr-2 leading-tight"
                  type="radio"
                  value={1}
                  defaultChecked
                  {...register("gameType")}
                />
                <span className="text-sm dark:text-slate-200">개인전</span>
              </label>
              <label className="block text-gray-700 font-bold mb-2">
                <input
                  className="mr-2 leading-tight"
                  type="radio"
                  value={2}
                  {...register("gameType")}
                />
                <span className="text-sm dark:text-slate-200">팀전</span>
              </label>
              <label className="block text-gray-700 font-bold mb-2">
                <input
                  className="mr-2 leading-tight"
                  type="radio"
                  value={4}
                  {...register("gameType")}
                />
                <span className="text-sm dark:text-slate-200">성공한 단어</span>
              </label>
            </div>
          </div>

          <div className="">
            <label className="block text-gray-700 dark:text-white font-bold mb-2">
              제한시간
            </label>
            <div className="mb-4">
              <label className="block text-gray-700 font-bold mb-2">
                <input
                  className="mr-2 leading-tight"
                  type="radio"
                  id="maxTime"
                  value={5}
                  {...register("maxTime")}
                />
                <span className="text-sm dark:text-slate-200">5</span>
              </label>
              <label className="block text-gray-700 font-bold mb-2">
                <input
                  className="mr-2 leading-tight"
                  type="radio"
                  id="maxTime"
                  value={10}
                  defaultChecked
                  {...register("maxTime")}
                />
                <span className="text-sm dark:text-slate-200">10</span>
              </label>
              <label className="block text-gray-700 font-bold mb-2">
                <input
                  className="mr-2 leading-tight"
                  type="radio"
                  id="not_participate"
                  value={15}
                  {...register("maxTime")}
                />
                <span className="text-sm dark:text-slate-200">15</span>
              </label>
              <label className="block text-gray-700 font-bold mb-2">
                <input
                  className="mr-2 leading-tight"
                  type="radio"
                  id="not_participate"
                  value={30}
                  {...register("maxTime")}
                />
                <span className="text-sm dark:text-slate-200">30</span>
              </label>
              <label className="block text-gray-700 font-bold mb-2">
                <input
                  className="mr-2 leading-tight"
                  type="radio"
                  id="not_participate"
                  value={60}
                  {...register("maxTime")}
                />
                <span className="text-sm dark:text-slate-200">60</span>
              </label>
            </div>
          </div>
        </div>

        {loading ? (
          <button
            type="button"
            className="bg-pink-500 hover:bg-pink-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          >
            loading...
          </button>
        ) : (
          <button
            type="submit"
            className="bg-pink-500 hover:bg-pink-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          >
            방만들기
          </button>
        )}
      </form>
    </div>
  );
};
export default MakeRoom;
